module.exports = __webpack_public_path__ + "img/kachel-ZAHNMUND_CISTURSPRAY.31c03a54.png";